import { Context, createContext } from 'react';
import { Config } from './config';

export type ConfigContextValue = {
  getConfig: () => Config;
};

export const ConfigContext: Context<ConfigContextValue> = createContext<ConfigContextValue>({
  getConfig: () => {
    throw new Error('Config context is not initialised yet');
  },
});
